import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { PaginationI } from '../../types/types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    active: {
      color: '#fff',
      fontSize: '14px',
      borderRadius: '25px',
      borderColor: '#888',
      zIndex: 1,
      textAlign: 'center',
      backgroundColor: '#888',
      paddingTop: '5px',

      height: '30px',
      // maxWidth: '28px',
      //paddingRight: 'auto',
      //marginLeft: '4px',
      //paddingLeft: 'auto',
      padding: 'auto',
    },
    pages: {
      color: 'black',
      float: 'left',
      textAlign: 'center',
      padding: '6px 6px',
      cursor: 'pointer',
      fontSize: '14px',
      marginLeft: '1px',
    },
  }),
);

const Pagination: React.FC<PaginationI> = ({
  pages,
  page,
  changePageNumber,
  lastPage,
}) => {
  const classes = useStyles();


  const pageIncrease = () => {
    if (page < lastPage) {
      changePageNumber(page + 1);
    }
  };

  const pageDecrease = () => {
    if (page > 1) {
      changePageNumber(page - 1);
    }
  };

  const changePage = (n: number) => {
    changePageNumber(n);
  };

  return (
    <div style={{ float: 'right', marginRight: '10px' }}>
      <Grid container style={{display:'flex',justifyContent:'space-between'}}>
        <Grid MuiGrid-item style={{ marginTop: '5px', marginRight: '10px' }}>
          <i
            onClick={() => pageDecrease()}
            style={{
              cursor: 'pointer',
              fontStyle: 'inherit',
              fontSize: '19px',
              color: 'black',
            }}>
            «
          </i>
        </Grid>

        {page > 5 ? (
          <Grid
            MuiGrid-item
            className={classes.pages}
            onClick={() => changePage(1)}>
            {' '}
            1
          </Grid>
        ) : (
          ''
        )}

        {page > 6 ? (
          <Grid MuiGrid-item className={classes.pages}>
            ...
          </Grid>
        ) : (
          ''
        )}

        {pages.map((p: number, index: number) => (
          <Grid
            style={{ width: '30px', margin: '1px' }}
            MuiGrid-item
            key={index}
            onClick={() => changePage(p)}>
            <div
              className={page === p ? `${classes.active}` : `${classes.pages}`}>
              {p}
            </div>
          </Grid>
        ))}
        {page < lastPage - 3 ? (
          <Grid MuiGrid-item className={classes.pages}>
            ...
          </Grid>
        ) : (
          ''
        )}
        {
          <Grid
            MuiGrid-item
            style={{ width: '30px', textAlign: 'center', margin: '1px' }}
            onClick={() => changePage(lastPage)}>
            <div
              className={
                page === lastPage ? `${classes.active}` : `${classes.pages}`
              }>
              {' '}
              {lastPage}
            </div>
          </Grid>
        }
        <Grid MuiGrid-item style={{ paddingLeft: '10px', marginTop: '5px' }}>
          <i
            onClick={() => pageIncrease()}
            style={{
              cursor: 'pointer',
              fontStyle: 'inherit',
              fontSize: '19px',
              color: 'black',
            }}>
            »
          </i>
        </Grid>
      </Grid>
    </div>
  );
};

export default React.memo(Pagination);
